import { render, staticRenderFns } from "./uploadVideoChoose.vue?vue&type=template&id=37f6b484&scoped=true&"
import script from "./uploadVideoChoose.vue?vue&type=script&lang=js&"
export * from "./uploadVideoChoose.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideoChoose.vue?vue&type=style&index=0&id=37f6b484&lang=scss&scoped=true&"
import style1 from "./uploadVideoChoose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f6b484",
  null
  
)

export default component.exports